import api from './api';

export const billingService = {
  getPlans: async () => {
    return api.get('/billing/plans');
  },

  getSubscriptionStatus: async () => {
    return api.get('/billing/subscription');
  },

  createCheckout: async (plan, interval) => {
    return api.post('/billing/checkout', { plan, interval });
  },

  createPortalSession: async () => {
    return api.post('/billing/portal');
  },

  cancelSubscription: async () => {
    return api.post('/billing/subscription/cancel');
  },

  reactivateSubscription: async () => {
    return api.post('/billing/subscription/reactivate');
  },
};

export default billingService;
